<template>
  <div class="splitted">
    <slot name="left"></slot>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: 'SplittedContainer'
}
</script>

<style lang="scss">
.splitted {
  @include wrapper;
  @include media("small-medium"){
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: layout("spacing");
  }

  width: 100%;

  // Is Fixed

  .is-fixed {
    @include media("small-medium"){
      width: 100%;
      order: 1;
      margin-bottom: layout("spacing");
    }
    @include media("large") {
      position: fixed;
      top: 0;
      right: 0;
      width: 50%;
      height: 100vh;
      z-index: 100;
    }

    flex: 0 1 auto;
  }

  // Is Scrollable

  .is-scrollable {
    @include add-top-bottom-gradient;
    @include media("small-medium"){
      order: 2;
      width: 100%;
    }
    @include media("large") {

      height: 100%;
      width: 50%;
    }

    overflow-x: hidden;
    flex: 0 1 auto;

    > div {
      flex: 0 1 auto;
    }
  }
}
</style>
